import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './routes';
import './styles/index.css';

export const createRoot = ViteReactSSG({ routes });

// Admin routes are SPA-only; public/_redirects rewrites /admin/* to /index.html
// at runtime so the React app boots and routes client-side.
// Note: vite-react-ssg emits nested paths without a leading slash
// (e.g. "admin", "admin/login"), so check both forms.
export function includedRoutes(paths: string[]): string[] {
  return paths.filter((p) => {
    const norm = p.startsWith('/') ? p.slice(1) : p;
    return norm !== 'admin' && !norm.startsWith('admin/');
  });
}
